import { useState } from "react";
import { Search, ChevronDown, Tag } from "lucide-react";
import { Button } from "../../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../ui/dropdown-menu";
import { SearchBarProps } from "../interfaces/EndpointInterfaces";
import { useTenants } from "../../../hooks/useTenants";
import useUserStore from "../../../services/userStore";
import TenantLists from "../TenantLists";
import DeviceTags from "./DeviceTags";



export default function SearchBar({
  placeholder = "Search...",
  onSearch,
  onSelectorChange,
  lastSelectedDevice,
  onTagsChange,
  resetValue
}: SearchBarProps) {
  const [searchQuery, setSearchQuery] = useState("");
  const [showTagsDialog, setShowTagsDialog] = useState(false);



  const handleSearch = (value: string) => {
    setSearchQuery(value);
    onSearch?.(value);
  };



  return (
    <div className="flex items-center space-x-4">
      <TenantLists onSelectorChange={onSelectorChange} isLabelNeeded={true} />

      {/* Search Input */}
      <div className="relative flex-1 max-w-md">
        <Search className="absolute w-4 h-4 transform -translate-y-1/2 left-3 top-1/2 text-muted-foreground" />
        <input
          type="text"
          placeholder={placeholder}
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
          className="w-full py-2 pl-10 pr-4 text-sm border rounded-lg border-input bg-background focus:outline-none focus:ring-2 focus:ring-ring"
          data-testid="input-search"
        />
      </div>

      {/* Tags Button */}
      {lastSelectedDevice && <Button
        variant="outline"
        className="flex items-center space-x-2"
        onClick={() => setShowTagsDialog(true)}
        data-testid="button-tags"
      >
        <Tag className="w-4 h-4" />
        <span>Tags</span>
      </Button>}



      <DeviceTags
        open={showTagsDialog}
        onOpenChange={setShowTagsDialog}
        device={lastSelectedDevice || null}
        onSave={(deviceId, existingTags, newTags) => {
          onTagsChange?.(deviceId, existingTags, newTags);
          setShowTagsDialog(false)
          resetValue?.()
        }}
        onClose={() => {
          resetValue?.()
        }}
      />

    </div>
  );
}